import { createSvgIcon } from "@mui/material/utils";

const CloudPlusIcon = createSvgIcon(
  <>
    {/* Cloud path */}
    <path
      d="M19.35 10.04c.65-4.04-2.35-8.04-7.35-8.04-3.61 0-6.61 2.66-6.95 5.01C2 8 1 10.64 1 13c0 4 2.69 6 6 6h11c2.21 0 4-1.79 4-4 0-2.08-1-4-3-4z"
      stroke="black"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Plus path */}
    <path
      d="M12 8v8m4-4H8"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </>,
  "CloudPlus"
);

export default CloudPlusIcon;
